var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgBold = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M4 8V2h8a3.5 3.5 0 1 1 0 7 4 4 0 0 1 0 8H4v-6.5zm3.5 2.5v4h3a2 2 0 1 0 0-4zm0-2.5V4.5h2.75a1.75 1.75 0 1 1 0 3.5z",
  clipRule: "evenodd"
})));
export default SvgBold;